import styled from "styled-components";

export const StyledTable = styled.ul``;
export const StyledTableRow = styled.li`
    display: grid;
    column-gap: ${props => props.theme.spacing(1)};
    grid-template-columns: [address] minmax(150px, 1fr) [actions] min-content;
    padding: ${props => props.theme.spacing(1, 2)};
    align-items: center;
    &:not(:first-child) {
        border-top: 1px solid ${props => props.theme.palette.ui.border};
    }
`;
